import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Accordion, Text } from '@frontend/design-system';
import { formatString } from '../../utils/helpers';

interface PmsVersionsAccordionProps {
  pmsVersions?: string[];
}

const PmsVersionsAccordion = ({ pmsVersions }: PmsVersionsAccordionProps) => {
  return (
    <Accordion variant='main' showBoxShadow>
      <Accordion.Item value='pms-versions'>
        <Accordion.Header>
          <Text weight='bold'>PMS Versions</Text>
        </Accordion.Header>
        <Accordion.Body css={containerStyle}>
          {pmsVersions?.map((chip) => (
            <Text key={chip}>{formatString(chip)}</Text>
          ))}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default PmsVersionsAccordion;

const containerStyle = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${theme.spacing(2)};
  align-items: start;

  @media (max-width: ${breakpoints.mobile.min}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${breakpoints.xsmall.max}px) {
    grid-template-columns: 1fr;
  }
`;
